module.exports = __webpack_public_path__ + "static/media/game_consoles2.09e96c65.png";